import React, { useState } from 'react'

import office from './img/AboutUs/office.png'
import ios from './img/AboutUs/ios.png'
import ios_min from './img/AboutUs/ios_min.png'
import ice from './img/AboutUs/ice.png'
import ice_min from './img/AboutUs/ice_min.png'
import kate from './img/AboutUs/kate.png'
import kate_min from './img/AboutUs/kate_min.png'
import alex from './img/AboutUs/alex.png'
import alex_min from './img/AboutUs/alex_min.png'

const AboutUsPage: React.FC = () => {
    const [isOpenUser, setIsOpenUser] = useState('ios')
    const [prevUser, setPrevUser] = useState('')
    const [hoverUser, setHoverUser] = useState('')

    const weAre = [
        {
            key: 'ios',
            name: 'Иосиф Иванов',
            position: 'Технический директор',
            about1: 'Программист с опытом работы более 10 лет.',
            about2: 'Руководил торговой площадкой ЭТП «СВФУ», работал в таких компаниях как ФГАОУ ВО «Северо-Восточный федеральный университет им. М.К. Аммосова», АО «Сахатранснефтегаз»',
            img: ios,
            img_min: ios_min,
        },
        {
            key: 'ice',
            name: 'Айсиэн Дьяконов',
            position: 'Директор по развитию',
            about1: 'Специалист в области закупок с опытом работы более 10 лет.',
            about2: 'Работал в таких компаниях как ФГАОУ ВО «Северо-Восточный федеральный университет им. М.К. Аммосова», АО «Сахатранснефтегаз»',
            img: ice,
            img_min: ice_min,
        },
        {
            key: 'kate',
            name: 'Екатерина Санникова',
            position: 'Генеральный директор',
            about1: 'Юрист с опытом работы более 10 лет.',
            about2: 'Работала в таких компаниях как ФГУП «Российская телевизионная и радиовещательная сеть», Министерство промышленности и геологии РС (Я), АО «Сахатранснефтегаз»',
            img: kate,
            img_min: kate_min,
        },
        {
            key: 'alex',
            name: 'Алексей Иванов',
            position: 'AI директор',
            about1: 'Специалист по разработке нейросетевых технологий с опытом работы более 5 лет.',
            about2: 'Обладатель патентов по нейросетевым технологиям',
            img: alex,
            img_min: alex_min,
        },
    ]

    return (
        <>
            <div className="flex flex-row w-full h-full items-center justify-center bg-[#d4d7daec] mb-10">
                <div className="relative flex flex-row w-[1200px] h-[400px] items-end justify-center gap-5">
                    {weAre.map((user) => {
                        const isOwnSelected = isOpenUser === user.key

                        const visibleClass = isOwnSelected
                            ? 'ease-in-out duration-300 transform transition-all opacity-100'
                            : 'ease-in-out duration-300 transform transition-all opacity-0'

                        const animateClass = isOwnSelected
                            ? 'ease-in-out duration-700 transform transition-all opacity-100 translate-x-[5px]'
                            : 'ease-in-out duration-700 transform transition-all opacity-0 translate-x-[-200px]'

                        return (
                            <div
                                key={user.key}
                                className={`absolute top-0 left0 flex flex-row h-full items-start justify-start ${visibleClass}`}
                            >
                                <div className="flex flex-col w-[400px] h-full items-center justify-center">
                                    <div
                                        className={`relative flex flex-col w-full h-full rounded-3xl p-10 items-start justify-start gap-3`}
                                    >
                                        <img
                                            className={`absolute top-0 left-0 w-full h-full rounded-3xl object-cover z-10 ${animateClass}`}
                                            src={user.img}
                                            alt={user.name}
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-col w-[600px] h-full items-center justify-center ">
                                    <div className="flex flex-col w-full h-full leading-[20px] items-center justify-center p-5 ">
                                        <div className="flex flex-col w-full h-full items-end justify-end gap-1 pb-2">
                                            <div
                                                className={`w-full text-left ${visibleClass}`}
                                            >
                                                <span className="text-[16px]">
                                                    {user.position}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex flex-col w-full h-fit items-center justify-start pb-5">
                                            <div
                                                className={`flex flex-col w-full h-full text-left items-start justify-start ${visibleClass}`}
                                            >
                                                <span className="w-full font-semibold text-[32px] ">
                                                    {user.name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex flex-col w-full h-full items-center justify-center pb-3">
                                            <div
                                                className={`w-full text-left ${visibleClass}`}
                                            >
                                                {user.about1}
                                                <br />
                                                {user.about2}
                                            </div>
                                        </div>
                                        <div className="flex flex-row w-full h-full items-center justify-start gap-3 ">
                                            {weAre.map((user1) => {
                                                const isHovered =
                                                    hoverUser === user1.key
                                                const isSelected =
                                                    isOpenUser === user1.key
                                                const isOtherHovered =
                                                    hoverUser &&
                                                    hoverUser !== user1.key

                                                const bgClass =
                                                    isHovered || isSelected
                                                        ? 'bg-[#FFFFFF]'
                                                        : 'bg-[#eaeaeaf4]'

                                                const scaleClass = isHovered
                                                    ? 'scale-[1.2]'
                                                    : isOtherHovered &&
                                                        isSelected
                                                      ? 'scale-[1]' // если другой наведен, то выбранный сжимается
                                                      : isSelected
                                                        ? 'scale-[1.2]'
                                                        : 'scale-[1]'

                                                return (
                                                    <div
                                                        key={user1.key}
                                                        className={`relative flex rounded-full items-center justify-center overflow-hidden w-[80px] h-[80px] transition-all duration-300 cursor-pointer ${bgClass} ${scaleClass}`}
                                                        onMouseEnter={() =>
                                                            setHoverUser(
                                                                user1.key
                                                            )
                                                        }
                                                        onMouseLeave={() =>
                                                            setHoverUser('')
                                                        }
                                                        onClick={() =>
                                                            setIsOpenUser(
                                                                user1.key
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            className="absolute rounded-3xl object-cover z-10 top-[-9px] left-[-8px] w-[160px] h-[160px]"
                                                            src={user1.img_min}
                                                            alt={user1.name}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="flex flex-row w-[1200px] h-full pb-5 px-10 rounded-3xl gap-5">
                <div className="relative flex flex-col w-[700px] h-full items-center justify-center">
                    <div className="flex flex-col w-full h-full leading-[20px] items-center justify-center p-5 gap-3">
                        <div className="flex flex-col w-full h-full items-center justify-center gap-1 pb-4">
                            <div className="w-full text-left">
                                Компания{' '}
                                <span className="font-semibold">
                                    «Технологии Закупок»
                                </span>{' '}
                                появилась из стремления упростить и
                                модернизировать одну из самых сложных и
                                бюрократических сфер – государственные закупки.
                            </div>
                        </div>
                        <div className="flex flex-col w-full h-full items-center justify-center gap-1 pb-4">
                            <div className="w-full text-left">
                                <span className="font-semibold">
                                    «Технологии Закупок»
                                </span>{' '}
                                – не просто ИТ-компания, а команда
                                профессионалов, чья миссия – автоматизировать
                                закупочные процессы делая их эффективными,
                                понятными и удобными.
                            </div>
                        </div>
                        <div className="flex flex-col w-full h-full items-center justify-center gap-1 pb-4">
                            <div className="w-full text-left">
                                Имея многолетний опыт работы в сфере
                                государственных закупок, мы видели на сколько
                                сложны бюрократические процедуры, как часто не
                                хватает времени, инструментов и ресурсов для их
                                выполнения.
                            </div>
                        </div>
                        <div className="flex flex-col w-full h-full items-center justify-center gap-1 pb-4">
                            <div className="w-full text-left">
                                Эти трудности вдохновили нас на создание
                                решения, которое бы не просто оптимизировало
                                процессы, но изменило привычные подходы к
                                закупочной деятельности.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col w-[500px] h-[350px] items-end justify-end">
                    <div className="relative flex flex-col w-full h-full bg-[#e4e7ea] rounded-3xl p-10 items-end justify-end gap-3">
                        <img
                            className="absolute top-0 left-0 w-full h-full rounded-3xl object-cover z-10"
                            src={office}
                            alt="Дашбоарды"
                        />
                        <div className=" absolute top-[10px] left-[90px] w-[350px] h-[90px] flex text-[30px] text-right font-semibold uppercase leading-[30px] rounded-3xl items-center justify-end p-5 bg-[#181818ba] text-[#FFFFFF] z-20">
                            Технологии
                            <br /> Закупок
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AboutUsPage
